"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Students_exports = {};
__export(Students_exports, {
  default: () => Students_default
});
module.exports = __toCommonJS(Students_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.09375 10.1914C10.0052 10.1914 10.7799 9.8724 11.418 9.23438C12.069 8.58333 12.3945 7.80208 12.3945 6.89062C12.3945 5.97917 12.069 5.20443 11.418 4.56641C10.7799 3.91536 10.0052 3.58984 9.09375 3.58984C8.18229 3.58984 7.40104 3.91536 6.75 4.56641C6.11198 5.20443 5.79297 5.97917 5.79297 6.89062C5.79297 7.80208 6.11198 8.58333 6.75 9.23438C7.40104 9.8724 8.18229 10.1914 9.09375 10.1914ZM9.09375 4.70312C9.70573 4.70312 10.2266 4.91797 10.6562 5.34766C11.0859 5.76432 11.3008 6.27865 11.3008 6.89062C11.3008 7.48958 11.0859 8.00391 10.6562 8.43359C10.2266 8.86328 9.70573 9.07812 9.09375 9.07812C8.49479 9.07812 7.98047 8.86328 7.55078 8.43359C7.12109 8.00391 6.90625 7.48958 6.90625 6.89062C6.90625 6.27865 7.12109 5.76432 7.55078 5.34766C7.98047 4.91797 8.49479 4.70312 9.09375 4.70312ZM11.4766 11.5H6.76953C5.72786 11.5 4.83594 11.8581 4.09375 12.5742C3.36458 13.2773 3 14.1237 3 15.1133V16.3633C3 16.5195 3.05208 16.6497 3.15625 16.7539C3.27344 16.8581 3.40365 16.9102 3.54688 16.9102C3.70312 16.9102 3.83333 16.8581 3.9375 16.7539C4.05469 16.6497 4.11328 16.5195 4.11328 16.3633V15.1133C4.11328 14.4232 4.3737 13.8372 4.89453 13.3555C5.41536 12.8607 6.04036 12.6133 6.76953 12.6133H11.4766C12.2188 12.6133 12.8438 12.8607 13.3516 13.3555C13.8724 13.8372 14.1328 14.4232 14.1328 15.1133V16.3633C14.1328 16.5195 14.1849 16.6497 14.2891 16.7539C14.4062 16.8581 14.543 16.9102 14.6992 16.9102C14.8424 16.9102 14.9661 16.8581 15.0703 16.7539C15.1875 16.6497 15.2461 16.5195 15.2461 16.3633V15.1133C15.2461 14.1237 14.875 13.2773 14.1328 12.5742C13.4036 11.8581 12.5182 11.5 11.4766 11.5ZM13.3906 4.85938C13.8333 4.88542 14.2109 5.06771 14.5234 5.40625C14.8359 5.73177 14.9922 6.12891 14.9922 6.59766C14.9922 7.05339 14.8359 7.45052 14.5234 7.78906C14.224 8.11458 13.8529 8.29036 13.4102 8.31641C13.2539 8.32943 13.1237 8.39453 13.0195 8.51172C12.9154 8.62891 12.8698 8.76562 12.8828 8.92188C12.8958 9.0651 12.9544 9.1888 13.0586 9.29297C13.1628 9.38411 13.2865 9.42969 13.4297 9.42969C13.4427 9.42969 13.4492 9.42969 13.4492 9.42969C13.4622 9.42969 13.4688 9.42969 13.4688 9.42969C14.2109 9.3776 14.8359 9.07812 15.3438 8.53125C15.8516 7.98438 16.1055 7.33984 16.1055 6.59766C16.1055 5.84245 15.8451 5.19141 15.3242 4.64453C14.8164 4.08464 14.1914 3.78516 13.4492 3.74609C13.306 3.73307 13.1758 3.77865 13.0586 3.88281C12.9414 3.98698 12.8763 4.11719 12.8633 4.27344C12.8633 4.41667 12.9089 4.54688 13 4.66406C13.1042 4.78125 13.2344 4.84635 13.3906 4.85938ZM15.2266 10.582C15.0833 10.582 14.9531 10.6341 14.8359 10.7383C14.7318 10.8424 14.6797 10.9727 14.6797 11.1289C14.6797 11.2852 14.7318 11.4219 14.8359 11.5391C14.9531 11.6432 15.0833 11.6953 15.2266 11.6953C15.6693 11.6953 16.0534 11.9167 16.3789 12.3594C16.7044 12.8021 16.8672 13.2513 16.8672 13.707V14.9766C16.8672 15.1198 16.9193 15.25 17.0234 15.3672C17.1406 15.4714 17.2773 15.5234 17.4336 15.5234C17.5898 15.5234 17.7201 15.4714 17.8242 15.3672C17.9284 15.25 17.9805 15.1198 17.9805 14.9766V13.707C17.9805 12.8867 17.7005 12.1641 17.1406 11.5391C16.5938 10.901 15.9557 10.582 15.2266 10.582Z",
      fill: "currentColor"
    }
  )
);
const SvgStudents = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Students_default = SvgStudents;
